module.exports = __webpack_public_path__ + "img/download-icon-dark.eab62dcd.svg";